import React, { useEffect, useState } from "react"
import "../../Css/root.css"
import axios from "../../axios"
import api from "../../api"
import Grid from '@mui/material/Grid'
import BasicSelector from "../BasicSelector"

export default function CatalogCourseSubjectFilter(props) {
    // Data states
    const [goals, setGoals] = useState([])
    const [subscriptions, setSubscriptions] = useState([])
    const [courses, setCourses] = useState([])
    const [subjects, setSubjects] = useState([])

    // Selection states
    const [selectedGoal, setSelectedGoal] = useState('')
    const [selectedSubscription, setSelectedSubscription] = useState('')
    const [selectedCourse, setSelectedCourse] = useState('')
    const [selectedSubject, setSelectedSubject] = useState('')

    const config = {
        headers: {
            "x-auth-token": localStorage.getItem("user"),
        }
    }

    // Select data props
    const goalData = {
        title: "Goals",
        items: goals,
        selected: selectedGoal
    }

    const subscriptionData = {
        title: "Subscriptions",
        items: subscriptions,
        selected: selectedSubscription
    }

    const courseData = {
        title: "Courses",
        items: courses,
        selected: selectedCourse
    }

    const subjectData = {
        title: "Subject",
        items: subjects,
        selected: props.selectedSubject
    }

    // Select elements
    const goalSelector = (
        <Grid item>
            <BasicSelector data={goalData} sx={{ width: 200 }} handleSelection={handleGoalSelection} />
        </Grid>
    )

    const courseSelector = (
        <Grid item>
            <BasicSelector data={courseData} sx={{ width: 200 }} handleSelection={handleCourseSelection} />
        </Grid>
    )

    const subjectSelector = (
        <Grid item>
            <BasicSelector data={subjectData} sx={{ width: 200 }} handleSelection={handleSubjectSelection} />
        </Grid>
    )

    useEffect(() => {
        getGoalsForFilter();
    }, []);

    // Data fetching and state handling functions
    async function getGoalsForFilter() {
        axios
            .get(api.getFilterGoals, config)
            .then((response) => {
                setGoals(response.data)
            })
            .catch((error) => {
                return error.response.status
            })
    }

    async function getCoursesForFilter(goalId) {
        axios
            .get(api.getCourseExplorerCatalogCourses + goalId, config)
            .then((response) => {
                setCourses(response.data)
            })
            .catch((error) => {
                return error.response.status
            })
    }

    async function getSubjectsForFilter(courseId) {
        axios
            .get(api.getFilterSubjects + courseId, config)
            .then((response) => {
                setSubjects(response.data)
            })
            .catch((error) => {
                return error.response.status
            })
    }

    function handleGoalSelection(goalId) {
        setSelectedGoal(goalId)
        props.handleCourseSelection('')
        props.handleSubjectSelection('')
        getCoursesForFilter(goalId)

        setSelectedCourse('')
        setSelectedSubject('')

    }

    function handleCourseSelection(courseId) {
        setSelectedCourse(courseId)
        props.handleCourseSelection(courseId)
        props.handleSubjectSelection('')
        getSubjectsForFilter(courseId)
        setSelectedSubject('')
    }

    function handleSubjectSelection(subjectId) {
        setSelectedSubject(subjectId)
        props.handleSubjectSelection(subjectId)
    }

    return (
        <Grid container direction="row" justifyContent="center" alignItems="center" spacing={4}>
            {goalSelector}
            {courseSelector}
            {subjectSelector}
        </Grid>
    )
}